import { ReactElement } from "react";

export default function IconUsers(): ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7956 0.5C8.84316 0.5 8.29914 2.14707 8.29914 2.14707C8.29914 2.14707 9.76793 3.05384 9.84333 5.43077C9.9183 7.7941 8.28012 9.75714 8.26142 9.77955L8.26126 9.77975C11.8315 11.1683 12.1509 12.7509 12.1509 12.7509C12.2982 12.7362 12.4497 12.7225 12.6035 12.7086C14.1784 12.5664 16 12.4019 16 10.8229C16 9.31921 13.5464 8.39521 12.6651 8.0633C12.5306 8.01266 12.4328 7.9758 12.3858 7.95277C12.031 7.77881 12.145 6.99708 12.2348 6.90785C13.035 6.11319 13.5467 4.76155 13.5467 3.43493C13.5467 2.10832 12.748 0.5 10.7956 0.5ZM8.60513 5.46945C8.60513 4.32307 7.7117 2.32425 5.52214 2.40237C3.33258 2.48048 2.54944 4.04106 2.54944 5.82933C2.54944 7.6176 4.03606 9.24143 4.03606 9.24143C4.28265 9.97851 3.90326 10.6383 3.69796 10.7653C3.64273 10.7995 3.53407 10.8393 3.38064 10.8954C2.96383 11.0481 2.21661 11.3216 1.3124 11.9323C0.0753649 12.7677 0 13.2614 0 14.0121C0 15.6301 3.43633 15.8921 5.58105 15.8921C7.72577 15.8921 11.2045 15.6963 11.0926 13.7701C11.0035 12.2376 8.9132 11.4033 7.76294 10.9443C7.61439 10.885 7.48152 10.832 7.37066 10.7845C6.90848 10.5866 6.8691 9.368 7.08082 9.17555C8.03909 8.3045 8.60513 6.61583 8.60513 5.46945Z"
        fill="#5A6072"
      />
    </svg>
  );
}
